import React from 'react';
import { MapPin } from 'lucide-react';
export function LegalFooter() {
  return <footer className="bg-rose-950 text-rose-200/60 py-16 px-4 text-sm leading-relaxed" data-id="element-87">
      <div className="max-w-4xl mx-auto space-y-8 text-center" data-id="element-88">
        <h4 className="text-rose-100 font-bold text-lg uppercase tracking-widest" data-id="element-89">
          Aviso Legal
        </h4>

        <div className="space-y-4 max-w-3xl mx-auto" data-id="element-90">
          <p data-id="element-91">
            La asesoría brindada por nuestros especialistas espirituales no
            tiene costo. Los trabajos espirituales tienen un valor asociado a la
            adquisición de materiales naturales, el cual será informado
            previamente.
          </p>
          <p data-id="element-92">
            Los resultados pueden variar según cada persona. Estos servicios son
            alternativos y no sustituyen atención médica, psicológica o
            psiquiátrica.
          </p>
          <p data-id="element-93">
            Dirigido exclusivamente a mayores de edad. Al solicitar el servicio,
            el usuario acepta nuestras políticas y condiciones.
          </p>
        </div>

        <div className="pt-8 border-t border-rose-900 flex items-center justify-center gap-2 text-rose-200" data-id="element-94">
          <MapPin className="w-4 h-4" data-id="element-95" />
          <span data-id="element-96">Templo de Ayuda La Luz Del Mundo – Miami, Florida</span>
        </div>
      </div>
    </footer>;
}